import DeleteMerchantButton from './DeleteMerchantButton';

export default DeleteMerchantButton;